import { render, staticRenderFns } from "./taskPanelTransferDataTable.vue?vue&type=template&id=3ee88e4a&"
import script from "./taskPanelTransferDataTable.vue?vue&type=script&lang=js&"
export * from "./taskPanelTransferDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports